module.exports = __webpack_public_path__ + "assets/img/1406.jpg?61ca152af26b9737096ea3995a4bc811";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/1406.jpg
// module id = 1076
// module chunks = 0